import React from 'react';
import SelectField from '../../Forms/Input/SelectField';
import DatePicker from '../../Forms/DatePicker/DatePicker';
import InputField from '../../Forms/Input/InputField';
import TextAreaField from '../../Forms/Input/TextAreaField';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';
import { useSale } from '../../../hooks/sale/useSale';

interface Props {
  type: 'purchase' | 'sale';
}

const PaymentConditionViewSection: React.FC<Props> = ({ type }) => {
  const { form: purchaseForm } = useBasePurchase();
  const { form: saleForm } = useSale();

  const paymentCondition =
    type === 'purchase'
      ? purchaseForm.paymentCondition
      : saleForm.paymentCondition;
  const comments =
    type === 'purchase' ? purchaseForm.comments : saleForm.comments;
  const baseDate =
    type === 'purchase'
      ? purchaseForm.purchaseDate || ''
      : saleForm.saleDate || '';
  const isCredit = paymentCondition?.code === 'CREDITO';

  const creditDueDate =
    type === 'purchase'
      ? purchaseForm.creditDueDate
      : saleForm.paymentCondition?.creditDueDate;
  const creditDays =
    type === 'purchase'
      ? purchaseForm.creditDays
      : saleForm.paymentCondition?.creditDays;

  return (
    <div className="mt-6 w-full rounded-sm border border-stroke bg-white p-6.5 shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="mb-6 grid gap-4 sm:grid-cols-2 md:grid-cols-3">
        <SelectField
          name="paymentCondition"
          label="Condición de Pago"
          iconKey="payment"
          value={paymentCondition?.id || ''}
          onChange={() => {}}
          disabled
          options={
            paymentCondition
              ? [{ value: paymentCondition.id, label: paymentCondition.name }]
              : []
          }
        />

        {isCredit && (
          <>
            <DatePicker
              name="creditDueDate"
              label="Fecha Plazo del Crédito"
              iconKey="calendar"
              value={creditDueDate || ''}
              onChange={() => {}}
              disabled
            />

            <InputField
              name="creditDays"
              label="Días Plazo del Crédito"
              iconKey="calendar"
              type="number"
              value={creditDays?.toString() || ''}
              onChange={() => {}}
              disabled
            />
          </>
        )}
      </div>

      <p className="pb-2 text-sm font-medium text-black dark:text-white">
        FECHA DEL DOCUMENTO:{' '}
        <span className="font-bold">{baseDate || 'Fecha no disponible'}</span>
      </p>

      <TextAreaField
        name="comments"
        label="Comentarios (Uso Interno)"
        placeholder="Comentarios/Observaciones"
        value={comments || ''}
        onChange={() => {}}
        iconKey='edit'
        disabled
      />
    </div>
  );
};

export default PaymentConditionViewSection;
